import Copyrights from '@/components/Copyrights';

const Footer = () => {
  return (
    <div className="app-layout__footer">
      <Copyrights />
    </div>
  );
};

export default Footer;
